import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native"

import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import LEAFLET from "leaflet";
import 'leaflet/dist/leaflet.css';
import {typeExport} from "../../redux/store/type";
// import LcoationMarker from "../../customviews/map/LcoationMarker";
import Locate from "leaflet.locatecontrol";
import {Tools} from "../../tools/Tools";

let myIcon = null;


/*
function MyComponent() {
    const map = useMap()
    return null
}
function HMMap(props) {
    let {showPlace, initialRegion, onRegionChangeComplete} = props;
    const position = [initialRegion.latitude, initialRegion.longitude]

    return (
        <View style={{height: '100%', width: '100%', backgroundColor: "red", overflow: 'hidden'}}>
            <MapContainer
                // ref={(rf) => this.refMap = rf}
                // ref={this.refMap}
                center={position}
                zoom={20}
                scrollWheelZoom={true}
                /!*   onDragend={(event) => {
                   }}
                   onMoveEnd={(event) => {
                   }}*!/

                //style={{position:'absolute'}}
                //  placeholder={<MapPlaceholder />}
            >
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://c.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker icon={myIcon}
                    //  key={item.toString()}
                        position={position}>
                    <Popup>
                        A pretty CSS3 popup. <br/> Easily customizable.
                    </Popup>
                </Marker>
                <MyComponent />


                {/!*     <MapConsumer>
                    {

                        (map) => {
                            // this.setState({position: map.getCenter()})
                            // onRegionChangeComplete(map.getCenter())
                            return null
                        }
                    }
                </MapConsumer>*!/}
            </MapContainer>
        </View>
    )
}

export default HMMap;*/
let container = null;
export default class HMMap extends Component {


    constructor(props) {
        super(props);
        let {showPlace, initialRegion, onRegionChangeComplete} = props
        const position = [initialRegion.latitude, initialRegion.longitude]
        this.state = {
            position: position,
            positionMarker: position,
            // value: 'احمد'
        }
        // this.refMap = React.createRef();
        this.mapRef = React.createRef();
        container = this;

        myIcon = LEAFLET.icon({
            //iconUrl: PathFile.image.location,
            iconUrl: typeExport._baseUrlImageAssets + "location.png",
            iconSize: props.typeMap ? [32, 32] : [64, 64],
            iconAnchor: props.typeMap ? [16, 32] : [32, 64],
            popupAnchor: null,
            shadowUrl: null,
            shadowSize: null,
            shadowAnchor: null
        });
    }

    componentWillReceiveProps(props) {


    }

    componentDidMount() {

        // const { options, startDirectly } = this.props;
        // const { map } = this.props.leaflet;
        //
        // const lc = new Locate(options);
        // lc.addTo(map);
        //
        // if (startDirectly) {
        //     // request location update and set location
        //     lc.start();
        // }

        /*        this.mapRef.current.locate().on("locationfound", function (e) {
          /!*          setPosition(e.latlng);
                    map.flyTo(e.latlng, map.getZoom());
                    const radius = e.accuracy;
                    const circle = L.circle(e.latlng, radius);
                    circle.addTo(map);
                    setBbox(e.bounds.toBBoxString().split(","));*!/
                });*/
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
        let {showPlace, initialRegion, onRegionChangeComplete} = this.props;
        // let {position, positionMarker} = this.state;
        const position = [initialRegion.latitude, initialRegion.longitude]

        setTimeout(
            () => {
                // var lc = Locate.control.locate().addTo(this.mapRef.current);
                // console.log("Locate",Locate.control)
                /*  this.mapRef.current.on('startfollowing', function() {
                     // map.on('dragstart', lc._stopFollowing, lc);
                  }).on('stopfollowing', function() {
                      //map.off('dragstart', lc._stopFollowing, lc);
                  });*/
                /*          LEAFLET.control.locate({
                              position: 'topleft',
                              drawCircle: true,
                              follow: false,  // follow with zoom and pan the user's location
                              stopFollowingOnDrag: false, // if follow is true, stop following when map is dragged (deprecated)
                              // if true locate control remains active on click even if the user's location is in view.
                              // clicking control will just pan to location
                              remainActive: false,
                              markerClass: LEAFLET.circleMarker, // L.circleMarker or L.marker
                              // range circle
                              circleStyle: {
                                  color: '#136AEC',
                                  fillColor: '#136AEC',
                                  fillOpacity: 0.15,
                                  weight: 2,
                                  opacity: 0.5
                              },
                              // inner marker
                              markerStyle: {
                                  color: '#136AEC',
                                  fillColor: '#2A93EE',
                                  fillOpacity: 0.7,
                                  weight: 2,
                                  opacity: 0.9,
                                  radius: 5
                              },
                              // changes to range circle and inner marker while following
                              // it is only necessary to provide the things that should change
                              followCircleStyle: {},
                              followMarkerStyle: {
                                  //color: '#FFA500',
                                  //fillColor: '#FFB000'
                              },
                              icon: 'fa fa-map-marker',  // fa-location-arrow or fa-map-marker
                              iconLoading: 'fa fa-spinner fa-spin',
                              circlePadding: [0, 0],
                              metric: true,
                              onLocationError: function(err) {
                                  // this event is called in case of any location error
                                  // that is not a time out error.
                                  alert(err.message);
                              },
                              onLocationOutsideMapBounds: function(control) {
                                  // this event is repeatedly called when the location changes
                                  control.stop();
                                  alert(control.options.strings.outsideMapBoundsMsg);
                              },
                              setView: true, // automatically sets the map view to the user's location
                              // keep the current map zoom level when displaying the user's location. (if 'false', use maxZoom)
                              keepCurrentZoomLevel: false,
                              showPopup: true, // display a popup when the user click on the inner marker
                              strings: {
                                  title: "Show me where I am",
                                  metersUnit: "meters",
                                  feetUnit: "feet",
                                  popup: "You are within {distance} {unit} from this point",
                                  outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
                              },
                              locateOptions: {
                                  maxZoom: Infinity,
                                  watch: true  // if you overwrite this, visualization cannot be updated
                              }
                          }).addTo(this.mapRef.current);*/
                /*      this.mapRef.current.locate({
                          position: 'topleft',
                          drawCircle: true,
                          follow: false,  // follow with zoom and pan the user's location
                          stopFollowingOnDrag: false, // if follow is true, stop following when map is dragged (deprecated)
                          // if true locate control remains active on click even if the user's location is in view.
                          // clicking control will just pan to location
                          remainActive: false,
                          markerClass: LEAFLET.circleMarker, // L.circleMarker or L.marker
                          // range circle
                          circleStyle: {
                              color: '#136AEC',
                              fillColor: '#136AEC',
                              fillOpacity: 0.15,
                              weight: 2,
                              opacity: 0.5
                          },
                          // inner marker
                          markerStyle: {
                              color: '#136AEC',
                              fillColor: '#2A93EE',
                              fillOpacity: 0.7,
                              weight: 2,
                              opacity: 0.9,
                              radius: 5
                          },
                          // changes to range circle and inner marker while following
                          // it is only necessary to provide the things that should change
                          followCircleStyle: {},
                          followMarkerStyle: {
                              //color: '#FFA500',
                              //fillColor: '#FFB000'
                          },
                          icon: 'fa fa-map-marker',  // fa-location-arrow or fa-map-marker
                          iconLoading: 'fa fa-spinner fa-spin',
                          circlePadding: [0, 0],
                          metric: true,
                          onLocationError: function(err) {
                              // this event is called in case of any location error
                              // that is not a time out error.
                              alert(err.message);
                          },
                          onLocationOutsideMapBounds: function(control) {
                              // this event is repeatedly called when the location changes
                              control.stop();
                              alert(control.options.strings.outsideMapBoundsMsg);
                          },
                          setView: true, // automatically sets the map view to the user's location
                          // keep the current map zoom level when displaying the user's location. (if 'false', use maxZoom)
                          keepCurrentZoomLevel: false,
                          showPopup: true, // display a popup when the user click on the inner marker
                          strings: {
                              title: "Show me where I am",
                              metersUnit: "meters",
                              feetUnit: "feet",
                              popup: "You are within {distance} {unit} from this point",
                              outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
                          },
                          locateOptions: {
                              maxZoom: Infinity,
                              watch: true  // if you overwrite this, visualization cannot be updated
                          }
                      })*/
                if (this.mapRef)
                this.mapRef.current.on('moveend', function (e) {
                    // var bounds = map.getBounds();
                    let location = e.target.getCenter();

                    if (onRegionChangeComplete) {
                        onRegionChangeComplete({latitude: location.lat, longitude: location.lng})
                        container.setState({
                            positionMarker: location
                        })
                    }
                });

            },
            1000
        );

    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    render() {
        let {showPlace, initialRegion, onRegionChangeComplete, zoom, showWrap, styleMap,typeMap} = this.props;
        // let {position, positionMarker} = this.state;
        const position = [initialRegion.latitude, initialRegion.longitude]

        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        return (

            <View style={styleMap ? styleMap : {
                height: '100%',
                width: '100%',
                backgroundColor: "red",
                overflow: 'hidden'
            }}>
                <MapContainer
                    {...this.props}
                    // ref={(rf) => this.refMap = rf}
                    //  ref={this.refMap}
                    whenCreated={mapInstance => {

                        this.mapRef.current = mapInstance
                    }}

                    /* ref={mapInstance => {
                         console.log("this.mapRef.current1",mapInstance)

                         this.mapRef.current = mapInstance
                     }}*/
                    center={position}
                    zoom={zoom ? zoom : 20}
                   // scrollWheelZoom={true}
                    style={styleMap ? styleMap : {height: '100%', width: '100%'}}
                    // onDragend={(event) => {
                    //
                    //
                    // }}
                    /*   onmoveend={()=>{
                           alert("dfkjhgudfhg")
                       }}
                       onMoveEnd={(event) => {
                           let location = event.target.getCenter();

                           if (onRegionChangeComplete) {
                               onRegionChangeComplete({latitude: location.lat, longitude: location.lng})
                               this.setState({
                                   positionMarker: event.target.getCenter()
                               })
                           }

                           // onRegionChangeComplete({latitude: location.lat, longitude: location.lng})

                       }}*/
                    // locate={()=>{
                    //
                    // }}
                    // onLocationfound={(e) => {
                    //     alert("onLocationfound")
                    //     console.log("onLocationfound", e)
                    // }}
                    //style={{position:'absolute'}}
                    //  placeholder={<MapPlaceholder />}
                >
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://c.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {this.props.showPlace ?
                        <Marker icon={myIcon}
                            //  key={item.toString()}
                                position={position}

                        >
                            {/*  <Popup>
                            A pretty CSS3 popup. <br/> Easily customizable.
                        </Popup>*/}
                        </Marker>
                        :
                        null
                    }

                    {/*<LcoationMarker bbox={bbox} setBbox={setBbox} />*/}

                </MapContainer>
            </View>
        );
    }


}
/*



const HMMap = (props) => {
    let {showPlace, initialRegion, onRegionChangeComplete} = props

    const position = [initialRegion.latitude, initialRegion.longitude]

    const [state, setState] = useState({sampleState: 'hello world', position: position, positionMarker: position,});

    return   <View style={{height: '100%', width: '100%', backgroundColor: "red", overflow: 'hidden'}}>
        <Map
            {...props}
            // ref={(rf) => this.refMap = rf}
            //  ref={this.refMap}
            ref={mapInstance => {
                this.mapRef = mapInstance
            }}
            center={position}
            zoom={20}
            scrollWheelZoom={true}
            // onDragend={(event) => {
            //
            //
            // }}
            onMoveEnd={(event) => {
                let location = event.target.getCenter();

                if (onRegionChangeComplete) {
                    onRegionChangeComplete({latitude: location.lat, longitude: location.lng})
                    this.setState({
                        positionMarker: event.target.getCenter()
                    })
                }

                // onRegionChangeComplete({latitude: location.lat, longitude: location.lng})

            }}
            locate={()=>{

            }}
            // onLocationfound={(e) => {
            //     alert("onLocationfound")
            //     console.log("onLocationfound", e)
            // }}
            //style={{position:'absolute'}}
            //  placeholder={<MapPlaceholder />}
        >
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://c.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {this.props.showPlace ?
                <Marker icon={myIcon}
                    //  key={item.toString()}
                        position={position}

                >
                    {/!*  <Popup>
                            A pretty CSS3 popup. <br/> Easily customizable.
                        </Popup>*!/}
                </Marker>
                :
                null
            }

            {/!*<LcoationMarker bbox={bbox} setBbox={setBbox} />*!/}

        </Map>
    </View>;
}
*/
